const features = [
  {
    icon: 'ri-spy-line',
    title: '独家一手爆料',
    desc: '51吃瓜旗下独家渠道，为台北娜娜、莫里秀等热门人物提供第一手资讯，确保内容时效领先。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日持续更新',
    desc: '暗网吃瓜保持每日30+条内容的更新频率，覆盖最新动态、深度回顾和专题合集，绝不掉队。',
  },
  {
    icon: 'ri-group-line',
    title: '百位人物覆盖',
    desc: '从玩偶姐姐到莫里秀，覆盖100+热门人物专题，人物索引清晰，让你一站看尽所有吃瓜内容。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度内容挖掘',
    desc: '不满足于表面信息，暗网吃瓜团队对每条爆料进行深度挖掘和多维度分析，呈现更完整的真相。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '理性吃瓜引导',
    desc: '提倡理性吃瓜文化，标注信息来源，引导读者健康看待娱乐八卦内容，营造良好的吃瓜社区氛围。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          为什么选择我们
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          五大核心优势，打造最值得信赖的吃瓜平台
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl border border-background-200/60 bg-background-100/50 p-5 md:p-6 text-center transition-all duration-300 hover:border-primary-500/30 hover:translate-y-[-2px]"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-500 text-2xl">
                <i className={item.icon}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-heading font-semibold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}